import React from 'react'
import { useAuthContext } from '../../hooks/useAuthContext'
import LoggedIn from './LoggedIn'
import Offline from './Offline'

export default function Home() {

  const {user} = useAuthContext()
  if(!user){
    return(<Offline />)
  }else{
    return(<LoggedIn />)
  }
}

